<template>
  <div ref="dropdownParent" class="filter-dropdown dropdown" :class="wrapperClassObject" :style="{'zIndex': dropdownShown ? 2 : 0}">
    <span v-if="!hideLabel" class="label-text">{{ wrapperLabel }}</span>
    <button
      :id="dropdownId"
      ref="dropdownToggle"
      class="filter-dropdown__toggle dropdown-toggle"
      :class="{ 'filter-dropdown__toggle--active': isActive }"
      type="button"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
    >
      {{ fieldLabel }}
    </button>
    <div
      class="filter-dropdown__content dropdown-menu"
      :aria-labelledby="dropdownId"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      id: '',
      dropdownShown: false
    };
  },
  props: {
    extraClasses: {
      type: String
    },
    dropdownId: {
      type: String,
      default: 'rw-filter-dropdown-' + Date.now() // better to pass an ID in instead of relying on this
    },
    fieldLabel: {
      type: String,
      default: ''
    },
    wrapperLabel: {
      type: String,
      default: ''
    },
    isActive: {
      type: Boolean,
      default: false
    },
    hideLabel: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    wrapperClassObject() {
      return {
        [this.extraClasses]: true,
        'filter-dropdown--has-label': !this.hideLabel
      };
    }
  },

  mounted(){
    const vm = this;
    $(this.$refs.dropdownParent).on('show.bs.dropdown', (evt) => { vm.dropdownShown = true; })
    $(this.$refs.dropdownParent).on('hide.bs.dropdown', (evt) => { vm.dropdownShown = false; })
  }
};
</script>

<style>

</style>
